const getError = async (res) => {
  if (!res) {
    const err = new Error('Shipsy API error')
    return err
  }

  const { message = '', errors = [], error = [] } = await res.json()
  // Multiple errors are passed as array of objects but just one is passed as an array of strings

  const errM = typeof error === 'string'
    ? error
    : error.map(e => e.message).join(', ') || ''

  const errMessage = errors.map(e => e.message ? e.message : e).join(', ') || ''

  const status = res.status
  const statusText = res.statusText

  const errorMessage = `Shipsy API error ${message} ${errMessage} ${errM} ${status}-${statusText}`

  const err = new Error(errorMessage)
  return err
}

module.exports = getError
